var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"packer_workspace"}},[_c('div',{staticClass:"ui cards"},_vm._l((_vm.packs),function(pack){return _c('Pack',{key:pack.identity,attrs:{"pack":pack,"selected_pack":_vm.selected_pack,"all_packs":_vm.all_packs}})}))])}
var staticRenderFns = []

export { render, staticRenderFns }